import LinkBase from './LinkBase';
import LinkWrapper from './LinkWrapper';

type Props = {
  label: string;
  href: string;
  size?: 'normal' | 'large';
  iconPosition?: 'left' | 'right';
  disabled?: boolean;
};

const Link = ({ label, href, size, iconPosition, disabled }: Props) => {
  return (
    <LinkWrapper disabled={disabled}>
      <a href={href} className={disabled ? 'pointer-events-none opacity-40' : 'cursor-pointer'}>
        <LinkBase label={label} size={size} iconPosition={iconPosition} disabled={disabled} />
      </a>
    </LinkWrapper>
  );
};

export default Link;
